import { ProfileDTO,} from './profile.dto';
import { GlobalResponseObject } from "@gtpl/shared-models/common-models";

export class GetProfileResponseModel extends GlobalResponseObject{
  data?:ProfileDTO;
  response:ProfileDTO[];
}

export class GetProfilePicResponseModel extends GlobalResponseObject{
  data?:any;
  response:any[];
}

export class getMyNetworkResponseModel extends GlobalResponseObject {
  data?:any;
  welfare?:any[];
  response:any[];
}



